export const environment = {
  production: true,
  appVersion: '26.0.8.0',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  siteKey:'6LfHjJEqAAAAAP0t9LJAVYSHsESpYw3JwoAmTT7T'
};
